"use strict"
const Writable = require('stream').Writable
const Readable = require('stream').Readable
const OutputStream = require('./lib/OutputStream')
const inherits = require('util').inherits

const removeFromPipes = function (state, output) {
  if (!state.pipes || state.pipes === output) {
    state.pipes = null
    state.pipesCount = 0
    return
  }
  state.pipes = state.pipes.filter(function (readable) {
    return readable !== output
  })

  if (state.pipes.length === 1) {
    state.pipes = state.pipes[0]
    state.pipesCount = 1
    return
  }

  state.pipesCount = state.pipes.length
}

function DispatcherStream (options) {
  if (!(this instanceof DispatcherStream)) {
    return new DispatcherStream(options)
  }
  Writable.call(this, {objectMode: true})
  options = options || {}
  options.outputs = options.outputs || []
  this.output = {}
  this._readableState = {
    pipesCount: 0,
    pipes: null,
    waitingForOutput: null,
    pendingData: null
  }
  this.dispatch = options.dispatch
  options.outputs.forEach(this.addOutput.bind(this))
  this._initDefaultHandler(options)
  this.on('finish', this.endAllOutputs.bind(this))
}
inherits(DispatcherStream, Writable)

const proto = DispatcherStream.prototype

proto._write = function (data, enc, next) {
  const key = this.dispatch(data)
  const output = (typeof key !== 'string' || !this.output[key]) ?
    this.defaultOutput : this.output[key]

  if (output._readableState.length < output._readableState.highWaterMark) {
    output.push(data)
    next()
  } else {
    this._readableState.waitingForOutput = output
    this._readableState.pendingData = data
  }
}

proto.addToPipes = function (output) {
  const state = this._readableState
  if (!state.pipes) {
    state.pipes = output
    state.pipesCount = 1
  } else if (Array.isArray(state.pipes)) {
    state.pipes.push(output)
    state.pipesCount = state.pipes.length
  } else {
    state.pipes = [state.pipes, output]
    state.pipesCount = 2
  }
}

proto._initDefaultHandler = function (options) {
  const handler = options.defaultHandler
  if (!(handler instanceof Writable || typeof handler === 'function')) {
    throw Error("defaultHandler property must be a function or Writable stream")
  }
  const readState = this._readableState
  const writeState = this._writableState
  this.defaultOutput = OutputStream({
    name: "*Default Output*",
    readState: readState,
    writeState: writeState
  })

  this.addToPipes(this.defaultOutput)
  if (handler instanceof Writable) {
    this.defaultOutput.pipe(handler)
  } else if (typeof handler === 'function'){
    this.defaultOutput.on('data', handler)
  }
}

proto.addOutput = function (key) {
  if (typeof key !== 'string') {
    throw Error("output key must be a string")
  }
  const readState = this._readableState
  const writeState = this._writableState
  var output = this.output[key]
  if (!output) {
    output = this.output[key] = OutputStream({
      name: key,
      readState: readState,
      writeState: writeState
    })
    this.addToPipes(output)
  }
  return output
}

proto.removeOutput = function (key) {
  if (!key) { return }
  const outputs = this.output
  var output
  if (key instanceof Readable) {
    output = key
    const keys = Object.keys(outputs)
    var i, length
    for (i = 0, length = keys.length; i < length; i += 1) {
      if (outputs[keys[i]] === output) {
        delete outputs[keys[i]]
      }
    }
  } else {
    output = outputs[key]
    if (!output) { return }
    delete outputs[key]
  }
  removeFromPipes(this._readableState, output)
  if (!output._readableState.ended) {
    output.push(null)
  }
}

proto.endAllOutputs = function () {
  const keys = Object.keys(this.output)
  keys.forEach(this.removeOutput.bind(this))
  removeFromPipes(this._readableState, this.defaultOutput)
  this.emit('end')
}

module.exports = DispatcherStream
